<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" @click="$emit('click')" class="icon pointer">
    <path d="M14.3643 3.99347L12.0073 1.63644C11.7469 1.37609 11.3248 1.37609 11.0645 1.63644L7.76465 4.93628C7.5043 5.19662 7.5043 5.61873 7.76465 5.87908L10.1217 8.23611C10.382 8.49646 10.8041 8.49646 11.0645 8.23611L14.3643 4.93628C14.6247 4.67593 14.6247 4.25382 14.3643 3.99347Z" stroke="#646464" stroke-width="1.33333" stroke-linejoin="round"/>
    <path d="M8.2359 10.1214L5.87888 7.76437C5.61853 7.50402 5.19642 7.50402 4.93607 7.76437L1.63623 11.0642C1.37588 11.3246 1.37589 11.7467 1.63623 12.007L3.99326 14.364C4.25361 14.6244 4.67572 14.6244 4.93607 14.364L8.2359 11.0642C8.49625 10.8039 8.49625 10.3817 8.2359 10.1214Z" stroke="#646464" stroke-width="1.33333" stroke-linejoin="round"/>
    <path d="M10.3574 5.64258L5.64331 10.3566" stroke="#646464" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  name: 'MoreIcon',
  emits: ['click']
}
</script>

<style scoped>
.pointer {
  cursor: pointer;
}

.icon {
  display: inline-block;
  vertical-align: middle;
}
</style>